import { createIcon } from './create-icon'

export const ExternalLink = createIcon({
  displayName: 'ExternalLink',
  paths: [
    'M853.333 128c23.552 0 42.667 19.115 42.667 42.667v256c0 23.552-19.115 42.667-42.667 42.667s-42.667-19.115-42.667-42.667v-152.981l-277.338 277.333c-16.64 16.64-43.691 16.64-60.331 0-16.683-16.683-16.683-43.691 0-60.373l277.278-277.312h-152.943c-23.552 0-42.667-19.115-42.667-42.667s19.115-42.667 42.667-42.667h256zM255.995 853.333c-47.128 0-85.332-38.148-85.333-85.274v-426.816c0.001-47.126 38.205-85.243 85.332-85.243h213.335c23.552 0 42.667 19.115 42.667 42.667s-19.115 42.667-42.667 42.667h-213.332v426.667h426.665v-213.333c0-23.552 19.115-42.667 42.667-42.667s42.667 19.115 42.667 42.667l0.004 213.333c0 47.13-38.208 85.333-85.333 85.333h-426.671z'
  ]
})
